import ReactGA from 'react-ga4';

/**
 * Google Analytics 配置和初始化
 */

// GA Measurement ID (从环境变量读取)
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

// 是否启用 GA（生产环境且有 ID 时启用）
const isEnabled = process.env.NODE_ENV === 'production' && GA_MEASUREMENT_ID;

/**
 * 初始化 Google Analytics
 */
export const initGA = () => {
  if (isEnabled) {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gaOptions: {
        siteSpeedSampleRate: 100, // 采样率 100%
      },
    });
    console.log('Google Analytics initialized:', GA_MEASUREMENT_ID);
  } else {
    console.log('Google Analytics disabled (dev mode or missing ID)');
  }
};

/**
 * 追踪页面浏览
 * @param {string} path - 页面路径
 * @param {string} title - 页面标题
 */
export const trackPageView = (path, title) => {
  if (isEnabled) {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title,
    });
    console.log('GA Page View:', path, title);
  }
};

/**
 * 追踪自定义事件
 * @param {string} category - 事件分类
 * @param {string} action - 事件动作
 * @param {string} label - 事件标签
 */
export const trackEvent = (category, action, label) => {
  if (isEnabled) {
    ReactGA.event({
      category,
      action,
      label,
    });
    console.log('GA Event:', category, action, label);
  }
};

/**
 * 追踪外部链接点击
 * @param {string} url - 外部链接 URL
 */
export const trackOutboundLink = (url) => {
  if (isEnabled) {
    ReactGA.event({
      category: 'Outbound Link',
      action: 'click',
      label: url,
    });
  }
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackOutboundLink,
};
